import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading...' }) => {
  const { colors } = useTheme();
  
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ backgroundColor: colors.background }}
    >
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-6xl font-bold mb-2" style={{ color: colors.primary }}>
            FMK
          </h1>
          <p className="text-sm" style={{ color: colors.textSecondary }}>
            Fuck • Marry • Kill
          </p>
        </div>
        
        <div className="flex justify-center mb-4">
          <div className="loading-spinner h-8 w-8 border-4 rounded-full"
            style={{ 
              borderColor: colors.surfaceVariant,
              borderTopColor: colors.primary 
            }}
          />
        </div>
        
        <p className="text-sm" style={{ color: colors.textSecondary }}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;